@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.location

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.locationpoint.LocationPointDto

object GetPassengerLocationPointEndpoint : EndPoint<GetPassengerLocationPointEndpoint.Request, GetPassengerLocationPointEndpoint.Response>() {
    class Request(
        val lat: Double,
        val lng: Double
    )

    class Response(
        val locationPoint: LocationPointDto?
    )
}